<template>
  <order-state-history-item :item="item">
    <template #title>
      Заказ оплачен
    </template>
    <template #icon>
      <div class="os-history-item__source_icon history-item-icon-wrapper">
        <img class="history-item-icon" src="img/icons/order-history/wallet.svg" alt="wallet" />
      </div>
    </template>
    <template #content>
      {{ description }}
    </template>
  </order-state-history-item>
</template>

<script>
  import PaymentType from '@/models/enums/PaymentType'
  import OrderStateHistoryItem from '../OrderStateHistoryItem.vue'
  import PaymentCompletionType from '@/models/enums/PaymentCompletionType'
  import { mapState } from 'vuex'

  export default {
    name: 'HistoryItemTypeOrderPaid',
    components: { OrderStateHistoryItem },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        currentEditOrder: state => state.orders.currentEditOrder,
      }),
      description () {
        const paymentType = PaymentType.getNameWithPlace(this.item.payment.type, this.currentEditOrder?.deliveryType, this.item.payment.mode)
        const amount = this.$options.filters.amountWithCurrency(this.item.payment.totalRub)
        const completion = this.completionType ? ` Проведён ${this.completionType.toLowerCase()}.` : ''

        return `${paymentType}, ${amount}.${completion}`
      },
      // как закрыли платёж по терминалу: ответ интеграции или отметка оператора; у старых записей нет
      completionType () {
        if (this.item.payment.type !== PaymentType.Terminal) return null

        const type = this.item.properties?.completionType
        return type ? PaymentCompletionType.getName(type) : null
      },
    },
  }
</script>

<style lang="less" scoped>
.history-item-icon {
  width: 22px !important;
  height: 22px !important;

  &-wrapper {
    margin-right: 0;
  }
}
</style>
